import React, { useEffect, useState, useRef } from 'react';
import { Input, Icon, Button } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions, resourceActions } from '../../actions';
import InfiniteScroller from 'react-infinite-scroller';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import './FontFamilyPanel.css';
import { generateImageLink } from '../../utils/design.utils';

const FontFamilyPanel = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedEntity = useSelector(state => state.design.selectedEntity);
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const currentFontFamily = useSelector(state => state.design.fontFamily);
  const fontsLoaded = useSelector(state => state.design.fontsLoaded);
  const fonts = useSelector(state => state.resource.fonts);
  const hasMore = useSelector(state => state.resource.hasMoreFont);
  const loading = useSelector(state => state.resource.fontStatus);
  const authToken = useSelector(state => state.authentication.user.authToken);

  const [closeIcon, setCloseIcon] = useState(false);
  const inputRef = useRef();
  const scrollPaneRef = useRef();
  const initRef = useRef(true);
  const returnButtonRef = useRef();

  useEffect(() => {
    if (!fonts || fonts.length === 0) {
      dispatch(resourceActions.search({ type: 'Font' }, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initRef.current) {
      initRef.current = false;
      return;
    }
    // fill until get scroll
    if (scrollPaneRef.current.scrollTopMax === 0 && hasMore) {
      let query = { type: 'Font' };
      if (_.get(inputRef, 'current.value', '').length > 0) {
        query.q = inputRef.current.value;
      }
      dispatch(resourceActions.search(query, false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fonts]);

  const handleSearchKeyPress = event => {
    if (event.key === 'Enter' || event.target.title === 'searchIcon') {
      if (_.isEmpty(inputRef.current.value)) {
        setCloseIcon(false);
      } else {
        scrollPaneRef.current.className = 'scroller-pan searched-content';
        returnButtonRef.current.ref.current.className = 'searchResetBtn active';
        dispatch(resourceActions.search({ type: 'Font', q: inputRef.current.value }, true));
      }
    }
  };

  const handleSearchClearClicked = () => {
    scrollPaneRef.current.className = 'scroller-pan';
    returnButtonRef.current.ref.current.className = 'searchResetBtn';
    setCloseIcon(false);
    inputRef.current.value = '';
    dispatch(resourceActions.search({ type: 'Font' }, true));
  };

  const handleClose = () => {
    dispatch(designActions.setSidePanel(null));
  };

  const onFontFamilyClicked = value => {
    const entityId = selectedEntity.type === 'TextGroup' ? selectedEntity.id[0] : selectedEntity.id;
    dispatch(designActions.addFont(value));

    const style = {
      type: 'fontFamily',
      all: entityId !== enabledEditorId,
      value,
    };

    if (selectedEntity.type === 'TextGroup')
      dispatch(designActions.changeTextEditorsStyle(selectedEntity.id, style));
    else dispatch(designActions.changeTextEditorStyle(selectedEntity.id, style));
  };

  return (
    <>
      <div className="panelsCloseStrip" onClick={handleClose}></div>
      <div className="fontFamilyPanelHolder">
        <div className="header">
          <span className="closeIcon btn left" onClick={handleClose}></span>
        </div>
        <div className="content">
          <div className="searchHolder">
            <Input
              onChange={(event, { value }) => setCloseIcon(value ? true : false)}
              onKeyPress={handleSearchKeyPress}
              icon
              fluid
              className="searchBox"
              placeholder={t('search')}
            >
              <Icon
                title="searchIcon"
                name="search"
                link
                style={{ right: 'auto', left: '1px' }}
                onClick={handleSearchKeyPress}
              />
              <input ref={inputRef} style={{ paddingLeft: '2.6em', paddingRight: '1em' }} />
              {closeIcon && <Icon name="remove" link onClick={handleSearchClearClicked} />}
            </Input>
            <Button
              ref={returnButtonRef}
              onClick={handleSearchClearClicked}
              className="searchResetBtn"
              content={t('goBack')}
            />
          </div>
          <div className="scrollerPanHolder">
            <div ref={scrollPaneRef} className="scroller-pan">
              {Object.keys(fontsLoaded).map((font, index) => (
                <span key={font} className={currentFontFamily === font ? 'active' : undefined}>
                  <img
                    alt={font.replaceAll('__', ' ')}
                    src={generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/resources/fonts/${font.replaceAll(
                      '__',
                      ' ',
                    )}/thumbnail.png` , authToken)}
                    style={{ width: 'unset' }}
                    onClick={() => onFontFamilyClicked(font)}
                  />
                </span>
              ))}
              <InfiniteScroller
                pageStart={0}
                threshold={100}
                initialLoad={false}
                hasMore={hasMore}
                loadMore={() => {
                  loading !== 'loading' &&
                    dispatch(
                      resourceActions.search(
                        { type: 'Font', q: _.get(inputRef, 'current.value', '') },
                        false,
                      ),
                    );
                }}
                useWindow={false}
                getScrollParent={() => scrollPaneRef.current}
              >
                {fonts &&
                  fonts.map((font, index) => (
                    <span
                      key={index}
                      className={
                        currentFontFamily === `${font.data.name}--${font.data.extension}`
                          ? 'active'
                          : undefined
                      }
                    >
                      <img
                        alt={font.data.name}
                        src={generateImageLink(`${process.env.REACT_APP_FILE_SERVER}/resources/fonts/${font.data.name}--${font.data.extension}/thumbnail.png` , authToken)}
                        style={{ width: 'unset' }}
                        onClick={() =>
                          onFontFamilyClicked(
                            `${font.data.name.replaceAll(' ', '__')}--${font.data.extension}`,
                          )
                        }
                      />
                    </span>
                  ))}
                {!fonts || (fonts.length === 0 && <span>{t('nothingToShow')}</span>)}
              </InfiniteScroller>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FontFamilyPanel;
